import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetErrorDetailsResData } from "./GetErrorDetailsResData";

const ENDPOINT = "/device_status/error_details";

export class GetErrorDetailsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetErrorDetailsReqData = null;

    constructor(params: GetErrorDetailsReqData) {
        super();
        this.params = Object.assign({}, params);
    }

    public async execute(): Promise<GetErrorDetailsResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetErrorDetailsResData(res);
    }
}

export class GetErrorDetailsReqData {
    model: string = null;
    code: string = null;
    area: string = null;
    supportedCashType: number = null;
    caosError: string = null;

    constructor(model: string, code: string, area: string, supportedCashType: number, error: string) {
        this.model = model;
        this.code = code;
        this.area = area;
        this.supportedCashType = supportedCashType;
        this.caosError = error;
    }
}
